import { Component } from "react";
import { NavLink } from "react-router-dom";

class Navbar extends Component {
  render() {
    return (
      <div className="bg-color1 fixed-top">
        <div className="container">
          <nav>
            <div className="title fw-bolder">Al-Qur'an Online</div>
            <ul>
              <li>
                <NavLink to="/" className="nav-link">
                  HOME
                </NavLink>
              </li>
              <li>
                <NavLink to="/surah" className="nav-link">
                  SURAH
                </NavLink>
              </li>
              <li>
                <NavLink to="/jws" className="nav-link">
                  JADWAL SHOLAT
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}
export default Navbar;
